import React from 'react';
import { BG_COLORS, NEWS } from '../data/schoolData';

export default function NewsPage() {
  return (
    <>
      <div className="page-hero">
        <h2>News &amp; Events</h2>
        <p>Stay updated with the latest happenings at our school</p>
      </div>
      <section style={{padding:'70px 0'}}>
        <div className="container">
          <div className="news-grid">
            {NEWS.map((n,i) => (
              <div className="news-card" key={i}>
                <div className="news-img" style={{background:BG_COLORS[i%BG_COLORS.length],display:'flex',alignItems:'center',justifyContent:'center',fontSize:'64px'}}>
                  {['🏆','🎓','🔬','🇮🇳','🎄','👩‍👩‍👧'][i]}
                </div>
                <div className="news-body">
                  <div className="news-date">{n.date}</div>
                  <h3>{n.title}</h3>
                  <p>{n.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
